<div [id]="'input-'+title" class="relative flex justify-end items-center">
  <input [id]="id ? id : 'datepicker'" type="text" [value]="datesToDisplay" [formGroup]="formGroup" [attr.formControlName]="controlName" class="block w-full bg-white truncate" [class]="compact() ? 'h-6 cursor-pointer border-none p-0 text-center font-semibold' : 'h-12 border rounded-s rounded-e text-base font-normal shadow-sm p-2.5 pr-8'" [disabled]="disabled" [placeholder]="literalService.get(placeholder ?? 'calendar.selectDate', true)" [attr.inputmode]="compact() ? 'numeric' : null" [attr.maxlength]="compact() ? APP.CALENDAR_TYPED_DATE_MAX_LENGTH : null" (input)="keepDateCharacters($event)" (click)="onInputClick($event)" autocomplete="off" />
  @if (!compact()) {
    <img [src]="images.user.calendar" class="absolute mr-2 cursor-pointer" height="20" width="20" alt="" aria-hidden="true" (click)="onInputClick($event)" />
  }
</div>
<div [id]="'dropdown-'+title" #calendarComponent class="calendar absolute z-50" [class.showOnTop]="showOnTop && !compact()" [class]="compact() && showOnTop ? 'bottom-full left-0 mb-2' : ''" [hidden]="!showCalendar">
  <div class="monthYear uppercase">
    <div class="nav" (click)="calendar.previousMonth()">
        <img [src]="images.arrowLeft" alt="prevMonth" class="w-6 h-6" />
    </div>
    <div>{{ literalService.get('calendar.months.' + calendar.displayMonth().toLowerCase(), true) }} {{ calendar.displayYear() }}</div>
    <div class="nav" (click)="calendar.nextMonth()">
        <img [src]="images.arrowRight" alt="nextMonth" class="w-6 h-6" />
    </div>
  </div>
  @if (showYear) {
    <div id="goToYear" class="flex justify-center items-center mb-2">
      <label class="mr-2 capitalize">{{ literalService.get('calendar.year') }}</label>
      <select class="w-full simple block px-3 py-2 bg-white border rounded-s rounded-e placeholder-slate-400 focus:outline-none" (change)="changeYear($event.target)">
        @for (year of years; track $index) {
          <option [value]="year.id" [selected]="year.id === getYear()">
              <label>{{ year.name }}</label>
          </option>
        }
      </select>
    </div>
  }
  @if (possibleMultipleDates) {
    <div class="flex justify-end mr-1 mb-2">
      <img [src]="images.multicheck" class="w-6 h-6 cursor-pointer" [ngClass]="{'filter-primary-purple-light': fullData.multipleDates, 'multipleDatesDisabled': !fullData.multipleDates}" (click)="changeMultipleDates()" />
    </div>
  }
  <div class="days">
    @for (weekDay of calendar.calWeekDays; track $index) {
      <span>{{ literalService.get('calendar.weekDays.' + weekDay.toLowerCase(), true) }}</span>
    }
  </div>
  <div class="dates">
    @for (item of utilsService.counter(calendar.daysInMonth()); track $index) {
      <button type="button" [ngStyle]="{'grid-column': $index === 0 ? calendar.firstDayNumber() : null}" [ngClass]="{ 'selected': selectedDate($index + 1), 'disabled': isDisabled($index + 1), 'notDisabled': !isDisabled($index + 1) }" (click)="!isDisabled($index + 1) ? selectDay($index + 1) : null">
          <time [ngClass]="{'disabled': isDisabled($index + 1)}">{{ $index + 1 }}</time>
      </button>
    }
  </div>
  @if (isRange) {
    <div class="flex justify-center align-middle">
      <input type="button" id="btnClose" class="uppercase font-bold mt-5 mr-2.5 border-2 h-10 w-28 secondary cursor-pointer" [value]="literalService.get('cancel', true)" />
      <input type="button" class="uppercase font-bold mt-5 ml-2.5 text-white h-10 w-28 primary cursor-pointer" [value]="literalService.get('apply', true)" />
    </div>
  }
</div>